import React, {Component, Fragment} from 'react'
import { Route, Switch } from "react-router-dom"
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { withTranslation } from 'react-i18next';
import ReactGA from 'react-ga'
import ReactGA4 from 'react-ga4';
import FormationQuizz from '../App/Formations/FormationQuizz/FormationQuizz';
import ResultPreview from './ResultPreview';
import { connect } from 'react-redux';
import { SentryRoute } from 'index';

class PreviewRouter extends Component {
  constructor(props){
    super(props)
    this.currentCat = this._getCurrentCat()
    this.oldAnimation = this._getTransition()
    this.setInterval = null
  }

  
	initializeReactGA() {
    const {config} = this.props
    const {ga_id} = config
    ReactGA.initialize(ga_id);
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactGA4.initialize(process.env.REACT_APP_MEASUREMENT_ID);
    ReactGA4.send({ hitType: "pageview", page: window.location.pathname + window.location.search, title: window.location.pathname });
  }
  
  _getCurrentCat = () => (
    this.props.location.pathname.split('/').filter(s => s !== "" )[0]
  )

  _sameCat = () => {
    return this.currentCat === this._getCurrentCat()
  }

  _getTransition = () => {
    let type = "fade";

    switch (this.props.history.action) {
      case "POP":
        switch (this.oldAnimation) {
          case "slide_in":
            type="slide_out"
            break;
          
          case "slide_out":
            type="slide_in"
            break;

          case "zoom_in":
            type="zoom_out"
            break;
        
          case "zoom_out":
            type="zoom_in"
            break;
          
            default:
            break;
        }
        break;



      case "PUSH":
      case "REPLACE":
      default:
        if(this.props.location.state && this.props.location.state.transitionName)
          type = this.props.location.state.transitionName
        break;
    }    
    return type
  }

  componentDidMount() {
    this.initializeReactGA()
  }

  componentDidUpdate() {
    this.initializeReactGA()
  }

  _onEntered = () => {
    this.oldAnimation = this._getTransition()
  }
  _onExit = (html) => {
    let newTransition = this._getTransition()
    html.classList.replace(`${this.oldAnimation}-exit`, `${newTransition}-exit`);
    html.classList.replace(`${this.oldAnimation}-exit-active`, `${newTransition}-exit-active`);
    html.classList.replace(`${this.oldAnimation}-exit-done`, `${newTransition}-exit-done`);
  }

  _renderSwitch() {
    const { match,location } = this.props
    return (
      <section className="route-section">
        <div className="route-section-inner">
          <Switch location={location}>
            <SentryRoute exact path={`${match.path}course/preview/:idPreview`} component={FormationQuizz} />
            <SentryRoute exact path={`${match.path}course/preview/:idPreview/result`} component={ResultPreview} />
            <SentryRoute component={FormationQuizz} />
          </Switch>  
        </div>
      </section>
    )
  }

	render() {    
    const { location } = this.props
    const transitionType = this._getTransition()
    return(
      <Fragment>
        <TransitionGroup className="transition-group">
          <CSSTransition
            key={location.key}
            classNames={transitionType}
            timeout={250}
            onEntered={this._onEntered}
            onExit={this._onExit}
            onExiting={this._onExit}
            onExited={this._onExit}
          >
            {this._renderSwitch()}
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    )
  }
}
const mapStateToProps = state => ({
  config: state.config
});

export default connect(mapStateToProps)(withTranslation()(PreviewRouter));